/**
 * Юрисдикция модуля — средний сегмент канонического ключа
 * `категория.юрисдикция.имя` (`compliance.rus.mvd_wanted`,
 * `compliance.kaz.wanted`, `verification.eu.vat`).
 *
 * Отдельный файл, а не константа внутри страницы: страновое измерение нужно
 * и каталогу, и боковому меню, и странице модуля. Пока словарь жил в каталоге,
 * он успел разойтись с реестром — модули Кыргызстана показывались как «KGZ».
 */

/** Название юрисдикции по коду. Неизвестный код показываем как есть. */
const TITLES: Readonly<Record<string, string>> = {
  rus: "Россия",
  kaz: "Казахстан",
  blr: "Беларусь",
  kgz: "Кыргызстан",
  uzb: "Узбекистан",
  arm: "Армения",
  pol: "Польша",
  eu: "Евросоюз",
  global: "Международные",
};

/** Юрисдикция ключа. Двухсегментные алиасы остались российскими. */
export function jurisdictionOf(moduleKey: string): string {
  const parts = moduleKey.split(".");
  return parts.length === 3 ? parts[1] : "rus";
}

export function jurisdictionTitle(code: string): string {
  return TITLES[code] ?? code.toUpperCase();
}

/**
 * Порядок юрисдикций: Россия — основной рынок, дальше соседние страны по
 * алфавиту, международные источники последними.
 */
export function compareJurisdictions(a: string, b: string): number {
  const rank = (code: string): number => (code === "rus" ? 0 : code === "global" ? 2 : 1);
  return rank(a) - rank(b) || jurisdictionTitle(a).localeCompare(jurisdictionTitle(b), "ru");
}

const SUFFIX_RE = new RegExp(`\\s*\\((${Object.values(TITLES).join("|")})\\)\\s*$`);

/**
 * Название модуля без страны в скобках: «Розыск должников (Казахстан)» →
 * «Розыск должников». Нужно там, где страна уже названа заголовком раздела и
 * повторять её в каждом пункте — шум. Скобки с другим содержимым
 * («Номер плательщика НДС (VIES)») остаются нетронутыми.
 */
export function stripJurisdictionSuffix(name: string): string {
  return name.replace(SUFFIX_RE, "");
}
